interface NavigationTranslations {
  en: {
    navbar: {
      whatsNew: string;
      navigation: {
        services: string;
        about: string;
        contact: string;
      };
      languageSelector: {
        english: string;
        welsh: string;
      };
    };
    footer: {
      companyInfo: {
        description: string;
      };
      quickLinks: {
        title: string;
        services: string;
        portfolio: string;
        testimonials: string;
        contact: string;
      };
      serviceAreas: {
        title: string;
        surroundingAreas: string;
      };
      contactInfo: {
        title: string;
      };
      bottomBar: {
        copyright: string;
        privacyPolicy: string;
        termsOfService: string;
        cookiePolicy: string;
      };
    };
  };
  cy: {
    navbar: {
      whatsNew: string;
      navigation: {
        services: string;
        about: string;
        contact: string;
      };
      languageSelector: {
        english: string;
        welsh: string;
      };
    };
    footer: {
      companyInfo: {
        description: string;
      };
      quickLinks: {
        title: string;
        services: string;
        portfolio: string;
        testimonials: string;
        contact: string;
      };
      serviceAreas: {
        title: string;
        surroundingAreas: string;
      };
      contactInfo: {
        title: string;
      };
      bottomBar: {
        copyright: string;
        privacyPolicy: string;
        termsOfService: string;
        cookiePolicy: string;
      };
    };
  };
}

export const navigationTranslations: NavigationTranslations = {
  en: {
    navbar: {
      whatsNew: "🌱 What's New: Check out our latest garden transformations and seasonal tips!",
      navigation: {
        services: "Services",
        about: "About",
        contact: "Contact"
      },
      languageSelector: {
        english: "English",
        welsh: "Cymraeg"
      }
    },
    footer: {
      companyInfo: {
        description: "Professional garden care and maintenance services in South Wales."
      },
      quickLinks: {
        title: "Quick Links",
        services: "Services",
        portfolio: "Portfolio",
        testimonials: "Testimonials",
        contact: "Contact"
      },
      serviceAreas: {
        title: "Service Areas",
        surroundingAreas: "Surrounding Areas"
      },
      contactInfo: {
        title: "Contact Us"
      },
      bottomBar: {
        copyright: "© {year} JC Gardening. All rights reserved.",
        privacyPolicy: "Privacy Policy",
        termsOfService: "Terms of Service",
        cookiePolicy: "Cookie Policy"
      }
    }
  },
  cy: {
    navbar: {
      whatsNew: "🌱 Beth sy'n Newydd: Edrychwch ar ein trawsnewidiadau gardd diweddaraf a'n cyngor tymhorol!",
      navigation: {
        services: "Gwasanaethau",
        about: "Amdana i",
        contact: "Cysylltwch"
      },
      languageSelector: {
        english: "English",
        welsh: "Cymraeg"
      }
    },
    footer: {
      companyInfo: {
        description: "Gwasanaethau gofal a chynnal a chadw gardd proffesiynol yn De Cymru."
      },
      quickLinks: {
        title: "Dolenni Cyflym",
        services: "Gwasanaethau",
        portfolio: "Portffolio",
        testimonials: "Tystiolaethau",
        contact: "Cysylltwch"
      },
      serviceAreas: {
        title: "Ardaloedd Gwasanaeth",
        surroundingAreas: "Ardaloedd Cyfagos"
      },
      contactInfo: {
        title: "Cysylltwch â Ni"
      },
      bottomBar: {
        copyright: "© {year} JC Gardening. Cedwir pob hawl.",
        privacyPolicy: "Polisi Preifatrwydd",
        termsOfService: "Telerau Gwasanaeth",
        cookiePolicy: "Polisi Cwcis"
      }
    }
  }
}; 